import { useDialogForm } from '@mews-commander/form';
import { lt, useFeatureFlag } from '@mews/framework';
import { DropDownButton, DropdownItem, Icon, IconName } from '@optimus-web/core';
import { FeatureFlag } from '@mews-commander/enums';
import { UploadFileDialogForm } from './UploadFileDialogForm';

export const AddDocumentsButton = () => {
    const [renderForm, toggleForm] = useDialogForm({
        renderForm: (props) => <UploadFileDialogForm {...props} />,
        size: 'small',
        title: lt('DocumentsUploadFileLabel'),
    });
    const isContractingDocumentGenerationEnabled = useFeatureFlag(FeatureFlag.contractingDocumentGenerationEnabled);

    return (
        <>
            <DropDownButton
                size="medium"
                label={lt('AddDocumentsButtonLabel')}
                icon={IconName.PlusSimple}
                type="button"
            >
                {isContractingDocumentGenerationEnabled && (
                    <DropdownItem
                        leftDetail={<Icon value={IconName.ActionLog} />}
                        label={lt('DocumentsGenerateFromTemplateFileLabel')}
                        onClick={() => {}}
                    />
                )}
                <DropdownItem
                    leftDetail={<Icon value={IconName.Upload} />}
                    label={lt('DocumentsUploadFileLabel')}
                    onClick={() => {
                        toggleForm();
                    }}
                />
            </DropDownButton>
            {renderForm()}
        </>
    );
};
